import _ from 'lodash';
import { icons } from '@cores/utils/workspaceIcon';
import Tooltip from 'element-ui/lib/tooltip';
import SavedToWorkspacePopper from '@/presentation/components/folders/PatentFamilyFieldTable/SavedToWorkspacePopper.vue';
import { injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
export const name = 'IN_WHICH_WORKSPACE.render';
// 默认显示模板
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const i18n = injectService(i18nSymbol);
    const cellValue = _.get(row, prop) || [];
    const max = 3;
    const box = (ws) => <i class="ws-icon-tiny">
        <img alt={ws.space_name} src={ws.space_s3_key || icons[ws.space_icon]}/>
    </i>;
    const limitedCellValue = cellValue.slice(0, max);
    const wsList = limitedCellValue.map((ws) => {
        return box(ws);
    });
    const spacelist = <Tooltip effect="light" visible-arrow={false} popper-class="pt-ui-tooltip in_which_workspace_popper">
        {/* @ts-ignore */}
        <SavedToWorkspacePopper pn={row.PN} infos={cellValue} slot="content"></SavedToWorkspacePopper>
        {/* @ts-ignore */}
        <div flex="-">
            {wsList}
            {cellValue.length > max ? <span class="ws-icon-more-tail">{cellValue.length - max}+</span> : null}
        </div>
    </Tooltip>;
    const empty = <span class="ws-icon-empty">{i18n.t('global.btn.no')}</span>;
    // @ts-ignore
    return [<div data-vxe-render={name} flex="-">
        {wsList.length ? spacelist : empty}
    </div>];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    return row[column.property];
}
export default {
    renderDefault,
    exportMethod,
};
